export default __webpack_public_path__ + "static/media/mountain_makovitsa_1280.3ffa5f0b.webp";